var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const SchedulerBlock = (_a) => {
    var { title, description, color, className, styles } = _a, otherProps = __rest(_a, ["title", "description", "color", "className", "styles"]);
    return (_jsx("div", Object.assign({}, otherProps, { className: "w-100 h-100 rounded p-1 text-white " + (className || ""), style: Object.assign({ overflow: "hidden", backgroundColor: color || "gray" }, styles), children: _jsx("div", { className: " d-flex flex-column h-100 justify-content-between", children: _jsxs("div", { children: [_jsx("span", { className: "font-weight-bold", children: title }), _jsx("div", { children: _jsx("small", { children: _jsx("em", { children: description }) }) })] }) }) })));
};
export default SchedulerBlock;
